import React from "react";
import CustomCheckBox from "../../../components/form/CustomCheckBox";

const TitleDisplayToggle = ({show = true, focusItem, setFocusItem, label, disabled = false}) => {


  return (
    <>{show &&
      <CustomCheckBox textSize="text-sm" disabled={disabled} checked={focusItem.extras?.show_title} onChange={(e) => !disabled && setFocusItem({
        ...focusItem,
        extras: {...focusItem.extras, show_title: e.target.checked}
      })} label={label ?? "Display in UI"}/>
    }
    </>
  );
};

export default TitleDisplayToggle;
